import { GetterTree } from 'vuex'
import { RootState } from '@/app/common/types/root-state.type'
import { ApiEntityState } from '@/app/api-entity/store/state'

export const getters: GetterTree<ApiEntityState, RootState> = {}
